<template>
  <div class="text-center">
    <h2>Welcome to my Website</h2>
    <p>Welcome to my website! This is a hobby for me and always a work in progress.</p>
    <div>
      <h3>About Me:</h3>
      <p>TODO</p>
    </div>
    <div>
      <p>Link to personal repo: <a href="https://github.com/martinb416">GitHub</a></p>
    </div>
    <hr/>
    <footer>&copy; Martin Buitrago 2019</footer>
  </div>
</template>

<script>
export default {
  name: 'HelloMartin',
  props: {}
}
</script>